import React from 'react';
import { useTranslation } from 'react-i18next';
import { EosComplianceFlag } from '../../../../../models/payroll';

interface Props {
  checks: EosComplianceFlag[];
}

export const EosComplianceChecklist: React.FC<Props> = ({ checks }) => {
  const { t } = useTranslation('common');
  const passed = checks.filter(c => c.passed).length;
  const total = checks.length;
  const pct = total > 0 ? Math.round((passed / total) * 100) : 0;

  return (
    <div className="rounded-xl border border-border bg-card p-4 flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <h4 className="text-sm font-semibold text-foreground">{t('Compliance Check')}</h4>
        <span className="text-xs text-muted-foreground">{passed}/{total} {t('passed')}</span>
      </div>
      <div className="h-2 w-full rounded-full bg-muted overflow-hidden">
        <div
          className={`h-full rounded-full transition-all ${passed === total ? 'bg-green-500' : 'bg-amber-500'}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <ul className="flex flex-col gap-2">
        {checks.map((check, i) => (
          <li key={i} className="flex items-start gap-2 text-sm">
            <span className={`mt-0.5 shrink-0 ${check.passed ? 'text-green-500' : 'text-amber-500'}`}>
              {check.passed ? '✓' : '⚠'}
            </span>
            <div>
              <p className="font-medium text-foreground">{check.label}</p>
              <p className="text-xs text-muted-foreground">{check.detail}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
